import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import GroupTree from "../../question/components/GroupTree.vue";
import { addPaperCategory, deletePaperCategory, getPaperCategoryList, updatePaperCategory } from "@/api/test-paper";
let ListAside = class ListAside extends Vue {
    get hasGlobalLoading() {
        // return this.$store.state.globalLoading
        return false;
    }
    async handleGetGroup(callback) {
        try {
            const { data } = await getPaperCategoryList();
            callback(data.data);
        }
        catch (_) { }
    }
    async handleSearch(params, callback) {
        try {
            const { data } = await getPaperCategoryList(params.keyword);
            callback(data.data);
        }
        catch (_) { }
    }
    async handleAdd(params, callback) {
        try {
            await addPaperCategory(params);
            this.$message.success("添加分类成功");
            callback();
        }
        catch (_) { }
    }
    async handleDelete(params, callback) {
        try {
            await deletePaperCategory(params);
            this.$message.success("删除分类成功");
            callback();
        }
        catch (_) { }
    }
    async handleUpdate(params, callback) {
        try {
            await updatePaperCategory(params);
            this.$message.success("重命名成功");
            callback();
        }
        catch (_) { }
    }
    handleNodeClick(node) {
        this.$emit("change-library-id", node.id);
    }
    handleTreeChange(treeData) {
        this.$emit("on-tree-change", treeData);
    }
    handleDeleteCategoryFail() {
        this.$confirm('该分类内存在试卷或下级分类，不可删除', {
            type: 'info',
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '知道了',
        });
    }
    async refreshTree() {
        try {
            const treeEl = this.tree;
            if (!treeEl)
                return;
            const treeData = await treeEl.refreshTree();
            this.$emit("on-tree-change", treeData);
        }
        catch (_) { }
    }
};
tslib_1.__decorate([
    Ref()
], ListAside.prototype, "tree", void 0);
ListAside = tslib_1.__decorate([
    Component({
        name: 'ListAside',
        components: {
            GroupTree,
        }
    })
], ListAside);
export default ListAside;
